"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Day = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var useDayStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: {
        position: 'relative',
        cursor: 'pointer',
        '&:empty': {
            cursor: 'default',
        },
    },
    inRange: {
        backgroundColor: theme.go.schemes.colors.system.SubtleAccent,
        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: '50%',
        },
        '&$firstInRange$lastInRange': {
            backgroundColor: 'transparent',
        },
    },
    firstInRange: {
        '&$selectedDay::before': {
            left: 0,
            backgroundColor: theme.go.schemes.colors.system.BgMain,
        },
    },
    lastInRange: {
        '&$selectedDay::before': {
            right: 0,
            backgroundColor: theme.go.schemes.colors.system.BgMain,
        },
    },
    today: {
        color: theme.go.schemes.colors.system.ControlMain,
    },
    dayLabel: __assign(__assign(__assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', top: -2, bottom: -2, borderRadius: '50%' }, theme.go.mixins.effects.Hovered('$root:hover &')), theme.go.mixins.effects.Pressed('$root:hover:active &')), { '&': {
            position: 'absolute',
            overflow: 'hidden',
        } }),
    selectedDay: {
        '& $dayLabel': {
            color: theme.go.schemes.components.lists.selectedTextColor,
            backgroundColor: theme.go.schemes.colors.system.SelectedListItem,
        },
    },
    disabled: {
        opacity: 0.6,
        pointerEvents: 'none',
    },
}); });
exports.Day = (0, react_1.memo)(function Day(_a) {
    var date = _a.date, day = _a.day, onClick = _a.onClick, inRange = _a.inRange, firstInRange = _a.firstInRange, lastInRange = _a.lastInRange, classes = _a.classes, selected = _a.selected, disabled = _a.disabled;
    var _b = useDayStyles(), inRangeClass = _b.inRange, firstInRangeClass = _b.firstInRange, lastInRangeClass = _b.lastInRange, disabledClass = _b.disabled, today = _b.today, dayLabel = _b.dayLabel, root = _b.root, selectedDay = _b.selectedDay;
    var dayClass = (0, utils_1.cn)(dayLabel, (0, utils_1.isToday)(date) ? today : null);
    var rootClass = [
        root,
        classes === null || classes === void 0 ? void 0 : classes.root,
        selected ? selectedDay : null,
        disabled ? disabledClass : null,
    ];
    if (firstInRange) {
        rootClass.push(inRangeClass, firstInRangeClass);
    }
    if (lastInRange) {
        rootClass.push(inRangeClass, lastInRangeClass);
    }
    if (inRange) {
        rootClass.push(inRangeClass);
    }
    var onDayClick = (0, react_1.useCallback)(function () {
        return onClick === null || onClick === void 0 ? void 0 : onClick(date);
    }, [date, onClick]);
    return (react_1.default.createElement("div", { className: utils_1.cn.apply(void 0, __spreadArray([], __read(rootClass), false)), onClick: day ? onDayClick : undefined }, day ? react_1.default.createElement("span", { className: dayClass }, day) : null));
});
